<script setup>
import { ref, computed } from "vue"
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' });

const props = defineProps({
  records: {
    type: Array,
    default: [ ]
  },
});
</script>

<template>
  <div class="bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-500 rounded-lg shadow overflow-y-scroll" v-auto-scroll>
    <div v-if="props.records && props.records.length > 0" v-for="record in props.records" class="badge" :class="{
      'badge-gray': record.type == 'comment',
      'badge-blue': record.type == 'command',
      'badge-green': record.type == 'success',
      'badge-yellow': record.type == 'warning',
      'badge-red': record.type == 'danger',
    }">{{ record.text }}<span class="absolute right-2" v-if="record.time">{{ record.elapsed }} [{{ record.time }}]</span></div>
    <div v-else class="m-3 text-gray-400">
      <slot name="empty">
        {{ $t('generic.empty_state') }}
      </slot>
    </div>
  </div>
</template>

<style scoped>
.badge {
  @apply relative font-mono font-medium mb-1 px-2.5 py-0.5 rounded;
}

.badge.badge-gray {
  @apply bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300;
}

.badge.badge-blue {
  @apply bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300;
}

.badge.badge-green {
  @apply bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300;
}

.badge.badge-yellow {
  @apply bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300;
}

.badge.badge-red {
  @apply bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300;
}
</style>
